import { useFormContext } from "react-hook-form";
import { FieldConfig } from "../../formConfig";

export default function LikertField({ field }: { field: FieldConfig }) {
  const { register } = useFormContext();
  const rows = field.likertRows ?? [];
  const cols = field.likertColumns ?? [];
  return (
    <div className="likert">
      <table>
        <thead>
          <tr>
            <th></th>
            {cols.map((c) => <th key={c}>{c}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r}>
              <td>{r}</td>
              {cols.map((c) => (
                <td key={c}>
                  <input type="radio" value={c} {...register(`${field.id}.${r}`)} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
